/**
 * SARS 2026/2027 tax year data.
 * Sources:
 * - SARS Income Tax Tables for Individuals 2026/2027 (Budget, 25 February 2026)
 * - SARS Medical Tax Credits 2026/2027
 * - Department of Employment and Labour UIF contribution limits (ceiling unchanged since 1 June 2021)
 *
 * Effective: 2026-03-01 to 2027-02-28
 * Last reviewed: 2026-09-18
 */

export interface TaxBracket {
  min: number
  max: number | null
  base: number
  rate: number
}

export const brackets2027: TaxBracket[] = [
  { min: 0, max: 245_100, base: 0, rate: 0.18 },
  { min: 245_101, max: 383_100, base: 44_118, rate: 0.26 },
  { min: 383_101, max: 530_200, base: 79_998, rate: 0.31 },
  { min: 530_201, max: 695_800, base: 125_599, rate: 0.36 },
  { min: 695_801, max: 887_000, base: 185_215, rate: 0.39 },
  { min: 887_001, max: 1_878_600, base: 259_783, rate: 0.41 },
  { min: 1_878_601, max: null, base: 666_339, rate: 0.45 },
]

export const rebates2027 = {
  primary: 17_820,
  secondary: 9_765,
  tertiary: 3_249,
}

export const medicalCredits2027 = {
  mainMember: 376,
  firstDependant: 376,
  additionalDependant: 254,
}

export const uif2027 = {
  employeeRate: 0.01,
  monthlyCap: 17_712,
}

export const retirement2027 = {
  deductionRate: 0.275,
  annualCap: 350_000,
}

export function taxYearLabel(): string {
  return '2026/2027'
}
